import { jsx } from "react/jsx-runtime";
import React__default from "react";
import { AnalyticsId } from "../../constants.js";
import styles from "./styles.module.scss";
const TagList = ({ children, testId }) => {
  return /* @__PURE__ */ jsx("ul", { className: styles["tag-list"], "data-testid": testId, "data-analyticsid": AnalyticsId.TagList, children: React__default.Children.map(children, (child) => /* @__PURE__ */ jsx("li", { className: styles["tag-list__item"], children: child })) });
};
export {
  TagList as default
};
//# sourceMappingURL=index.js.map
